<template>
  <header class="clienteHeader">
    <div class="clienteHeaderConteudo">
      <nav class="clienteHeaderNavegacao" aria-label="Navegação principal">
        <router-link to="/" exact class="clienteHeaderItem">
          <i class="fa fa-home" aria-hidden="true"></i>
          <span>Início</span>
        </router-link>
        <router-link to="/fav" class="clienteHeaderItem">
          <i class="fa fa-star-o" aria-hidden="true"></i>
          <span>Favoritos</span>
        </router-link>
        <router-link
          v-if="podeVerMeusDados"
          to="/meus-dados"
          class="clienteHeaderItem"
        >
          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
          <span>Minha conta</span>
        </router-link>
      </nav>

      <div class="clienteHeaderUsuario">
        <span v-if="nomeUsuario">{{ nomeUsuario }}</span>
        <button type="button" title="Sair" aria-label="Sair" @click="sair">
          <i class="fa fa-sign-out" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "ClienteHeader",
  computed: {
    usuario() {
      return this.$sessao && this.$sessao.usuario
        ? this.$sessao.usuario
        : {};
    },
    nomeUsuario() {
      return this.usuario.nome || this.usuario.email || "";
    },
    tipoUsuarioNormalizado() {
      return (this.usuario.tipoUsuario || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    podeVerMeusDados() {
      return this.tipoUsuarioNormalizado !== "Degustacao";
    },
  },
  methods: {
    sair() {
      localStorage.removeItem("ckd");
      localStorage.removeItem("ckdCch");
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.clienteHeader {
  background: #202529;
  border-bottom: 3px solid #2e9b67;
  box-shadow: 0 2px 8px rgba(20, 25, 28, 0.2);
  height: 64px;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1040;
}

.clienteHeaderConteudo {
  align-items: stretch;
  display: flex;
  height: 61px;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 26px;
}

.clienteHeaderNavegacao {
  display: flex;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.clienteHeaderNavegacao::-webkit-scrollbar {
  display: none;
}

.clienteHeaderItem {
  align-items: center;
  border-bottom: 3px solid transparent;
  color: #cbd2d6;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  gap: 7px;
  padding: 0 14px;
  text-decoration: none;
  white-space: nowrap;
}

.clienteHeaderItem:hover {
  background: #292f33;
  color: #ffffff;
  text-decoration: none;
}

.clienteHeaderItem.router-link-active {
  background: #292f33;
  border-bottom-color: #43b77f;
  color: #ffffff;
}

.clienteHeaderItem i {
  font-size: 14px;
  text-align: center;
  width: 15px;
}

.clienteHeaderUsuario {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-left: auto;
  padding-left: 18px;
}

.clienteHeaderUsuario > span {
  color: #aeb8be;
  font-size: 10px;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clienteHeaderUsuario button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #d5dadd;
  cursor: pointer;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.clienteHeaderUsuario button:hover {
  background: #30373b;
  color: #ffffff;
}

@media (max-width: 767px) {
  .clienteHeaderConteudo {
    padding: 0 8px;
  }

  .clienteHeaderItem {
    gap: 5px;
    padding: 0 10px;
  }

  .clienteHeaderUsuario {
    gap: 0;
    padding-left: 2px;
  }

  .clienteHeaderUsuario > span {
    display: none;
  }
}
</style>
